import React, { FC } from 'react'
import { escapeRegExp } from 'lodash'

type HighlightedProps = {
  text: string
  highlight?: string
}

export const Highlighted: FC<HighlightedProps> = ({ text = '', highlight = '' }) => {
  if (!highlight.trim()) {
    return <span>{text}</span>
  }

  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi')
  const parts = text.split(regex)

  return (
    <span>
      {parts
        .filter(part => part)
        .map((part, i) => {
          if (regex.test(part)) {
            return (
              <b key={i} style={{ background: 'var(--bs-yellow)' }}>
                {part}
              </b>
            )
          }

          return <span key={i}>{part}</span>
        })}
    </span>
  )
}
